'use client';
import { Button } from '@/components/ui/button';
import { PlaceHolderImages } from '@/lib/placeholder-images';
import Image from 'next/image';
import Link from 'next/link';

export function Hero() {
  const heroImage = PlaceHolderImages.find((img) => img.id === 'hero-image');

  return (
    <section 
      className="bg-secondary"
    >
      <div 
        className="container mx-auto px-4 grid md:grid-cols-2 gap-8 items-center"
      >
        <div className="space-y-6 text-center md:text-left">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold font-headline tracking-tight">
            <span className="bg-gradient-to-r from-primary via-accent to-primary bg-[200%_auto] bg-clip-text text-transparent animate-gradient-shift">
              Upbeat Brain Game
            </span>
          </h1>
          <p className="text-xl md:text-2xl font-semibold text-foreground">
            Train Intelligent Mind to Win Over Challenges
          </p>
          <p className="text-muted-foreground text-lg">
            Unlock your child's full potential with our world-class programs in brain development, confidence building, and future-ready skills.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
            <Button asChild size="lg" variant="accent" className="rounded-full">
              <Link href="/book-demo">Book a Free Demo Class</Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="rounded-full">
              <Link href="/programs">Explore Programs</Link>
            </Button>
          </div>
        </div>
        <div className="relative h-96 md:h-[500px] w-full">
          {heroImage && (
            <Image
              src={heroImage.imageUrl}
              alt={heroImage.description}
              fill
              priority
              className="object-contain rounded-2xl shadow-lg"
              data-ai-hint={heroImage.imageHint}
              sizes="(max-width: 768px) 100vw, 50vw"
            />
          )}
        </div>
      </div>
    </section>
  );
}
